/**
 * Price breakdown helpers — aligned with NewBooking.jsx (standard booking, no part-load).
 */
import { calculateB2bBookingPrice } from './b2bPricing';
import { normalizeDiscountPercent } from './bookingQuoteBooking';

function applyDiscountToAmount(amount, discountPercent, tollAmount = 0) {
  const total = Number(amount);
  const toll = Number(tollAmount);
  if (!Number.isFinite(total)) return 0;
  const pct = normalizeDiscountPercent(discountPercent);
  if (pct <= 0) return Math.ceil(total);
  const baseFare = total - toll;
  return Math.ceil(baseFare * (1 - pct / 100) + toll);
}

export function getEffectiveAmount(computedAmount, override) {
  const parsed = parseFloat(override);
  if (override !== '' && Number.isFinite(parsed) && parsed >= 0) return parsed;
  return computedAmount;
}

export function getPriceBreakdown(vehicleOption, discountPercent, isB2b = false, hasGstin = false) {
  if (!vehicleOption) return null;
  const pct = normalizeDiscountPercent(discountPercent);
  if (isB2b) {
    return calculateB2bBookingPrice(vehicleOption, pct);
  }
  const toll = parseFloat(vehicleOption.toll_price_applied || 0);
  const baseTotal = applyDiscountToAmount(parseFloat(vehicleOption.estimated_price), pct, toll);
  if (hasGstin) {
    const grandTotal = Math.ceil(baseTotal * 1.05);
    const gstAmount = grandTotal - baseTotal;
    return {
      grandTotal,
      discountPercentage: pct,
      gstAmount,
      discountAmount: pct > 0
        ? Math.ceil((parseFloat(vehicleOption.estimated_price) - toll) * (pct / 100))
        : 0,
    };
  }
  return {
    grandTotal: baseTotal,
    discountPercentage: pct,
    gstAmount: 0,
    discountAmount: pct > 0
      ? Math.ceil((parseFloat(vehicleOption.estimated_price) - toll) * (pct / 100))
      : 0,
  };
}
